exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".waiting-room-sidebar--377WLLa_LoJlTEwI-l8WVf {\n  flex-shrink: 0;\n  border: 1px solid #7d7d7d;\n  border-radius: 4px;\n  width: 315px;\n  box-sizing: border-box;\n  overflow: hidden;\n  padding: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"sidebarContainer": "waiting-room-sidebar--377WLLa_LoJlTEwI-l8WVf",
	"sidebarContainer": "waiting-room-sidebar--377WLLa_LoJlTEwI-l8WVf"
};